module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/font/notokr-medium.woff
// module id = iSS/
// module chunks = 0